<template>
<div>
	<div v-if="stage == 'assembly-pick'" class="assembly-picker mt-3">
		<div class="row">
			<div v-for="tag in tags" class="col-sm-3">
				<label>
					<input type="checkbox" v-model="selectedTags" :value="tag.friendly_slug" v-on:change="fetchAssemblies">
					{{tag.name}}
				</label>
			</div>
		</div>

		<div v-if="localSpinner" class="d-flex flex-row align-items-center">
			<i class="fa fa-spinner fa-spin fa-2x"></i>
		</div>

		<table-list v-if="showRecords && !localSpinner"
			:fields="fields"
			:records="mutatedAssemblies"
			:sortable="true"
			:has-edit="true"
			edit-button-text="Select"
			:other-buttons="[
				{
					text: 'Details',
					icon: 'fa-eye',
					click: 'openAssemblyDetails',
					title: 'See the materials that make up this assembly',
					class: 'btn-light'
				}
			]"
			v-on:openAssemblyDetails="openAssemblyDetails"
			v-on:edit="selectAssembly"
			:hide-record-count='true'>
		</table-list>
		<p v-else-if="!localSpinner">
			Select a tag to show matching assemblies
		</p>
	</div>
	<div v-else-if="stage == 'assembly-config'" class="assembly-config">

		<h3>{{ selectedAssembly.description }}</h3>

		<template v-if="selectedAssembly.unit_type != 'Unit'">
			<form-group 
				:label="qtyLabel" 
				col-class="col-md-4">
				
				<div class="d-flex align-items-center flex-wrap">
					<field 
						:params="{type:'number',step:0.05}"
						v-model="selectedLinearQty">
					</field>
					<div class="text-muted ml-2">Linear qty in each assembly</div>
				</div>
			</form-group>

			<form-group
				label="Number of Segments" 
				col-class="col-md-4">

				<div class="d-flex align-items-center flex-wrap">
					<field 
						:params="{type:'number',step:1}"
						v-model="selectedNumSegments">
					</field>
					<div class="text-muted ml-2">No. of segments in each assembly</div>
				</div>
			</form-group>
		</template>

		<form-group 
			label="Qty of Assemblies" 
			col-class="col-md-4">

			<div class="d-flex align-items-center flex-wrap">
				<field 
					:params="{type:'number',step:1}"
					v-model="selectedQty">
				</field>
				<div class="text-muted ml-2">No. of complete assemblies</div>
			</div>
		</form-group>

		<button type="button" class="btn btn-success float-right" v-on:click="confirmAssembly">
			<i class="fa fa-check"></i>
			Confirm
		</button>
	</div>

	<assembly-details-modal :readonly="true"
		:visible="assemblyDetailsModal.visible"
		title="Assembly Anatomy"
		:record="assemblyDetailsModal.record"
		v-on:closeModal="assemblyDetailsModal.visible = false">
	</assembly-details-modal>
</div>
</template>
<script type="text/javascript">
import TableList from "../TableList"
import SearchBar from "../SearchBar"
import Field from "@/components/Field"
import FormGroup from "@/components/FormGroup"

import AssemblyMixins from "@/mixins/AssemblyMixins.js"

export default {
	components: {
		TableList,
		SearchBar,
		FormGroup,
		Field,
		AssemblyDetailsModal: () => import("@/components/super_components/AssemblyDetailsModal")
	},
	mixins: [AssemblyMixins],
	props: [
	
	],
	data() {
		return {
			tags: [],
			records: [],
			fields: [
				{label: 'Description',key:'description'},
				{label: 'Tags',key:'tagsList'}
			],
			selectedAssembly: null,
			selectedLinearQty: 1,
			selectedQty: 1,
			selectedNumSegments: 0,
			stage: 'assembly-pick',
			selectedTags: [],
			showRecords: false,
			localSpinner: false,
			assemblyDetailsModal: {
				visible: false,
				title: "",
				record: null
			}
		}
	},
	computed: {
		qtyLabel() {
			if (this.selectedAssembly) {
				return "Length (by "+this.selectedAssembly.unit_type+")"
			}
			else
				return "Qty"
		},
		mutatedAssemblies() {
			return this.records.map(as => {

				as.tagsList = ""
				if ("AssemblyTag" in as && as.AssemblyTag) {
					as.tagsList = as.AssemblyTag.reduce((acc,tag) => {
						return acc+"<span class='badge badge-primary mr-1'>"+tag.name+"</span>"
					},"")
				}

				return as
			})
		},
	},
	methods: {
		selectAssembly(assembly) {
			this.stage = "assembly-config"
			this.selectedAssembly = assembly
		},
		openAssemblyDetails(assembly) {
			this.assemblyDetailsModal.visible = true
			this.assemblyDetailsModal.title = "Assembly Anatomy: " + assembly.description
			this.assemblyDetailsModal.record = assembly
		},
		confirmAssembly() {
			//compiled materials and emit 'select' once per each material per qty

			let vm = this

			let params = {
				include: [{
					model:"MaterialAssemblyItem",
					include: ["Material","LabourAction"]
				}]
			}

			this.getJSON("MaterialAssembly/find/"+this.selectedAssembly.slug,params,true).then(response => {
				if (response.success) {

					let items = []
					if (response.data.MaterialAssemblyItem) 
						items = vm.createMaterialItemsFromAssemblyItems(response.data.MaterialAssemblyItem,vm.selectedQty,vm.selectedNumSegments,vm.selectedLinearQty)

					vm.$emit("selectAssembly",{
							materials: items.materials,
							labourActions: items.labourActions,
							num_segments: vm.selectedNumSegments,
							assembly: vm.selectedAssembly,
							linear_qty: +vm.selectedLinearQty,
							qty: +vm.selectedQty
						})

					vm.stage = "assembly-pick"

					vm.selectedAssembly = null
					vm.selectedQty = 1
					vm.selectedLinearQty = 1
					vm.selectedNumSegments = 0
				}
			})
		},
		fetchAssemblies() {
			this.localSpinner = true

			let vm = this

			let params = {
				filters: [
					["AssemblyTag.friendly_slug",this.selectedTags]
				],
				include: ["AssemblyTag"]
			}

			this.getJSON("MaterialAssembly/get",params,true).then(response => {
				vm.localSpinner = false
				if (response.success) {
					vm.showRecords = true
					vm.records = response.data
				}
			})
		},
		fetchData() {
			let vm = this

			this.getJSON("AssemblyTag/get").then(response => {
				if (response.success)
					vm.tags = response.data
			})
		}
	},
	created() {
		this.fetchData()
	}
}
</script>

<style type="text/css" scoped>
	.assembly-makeup-location-heading {
		font-size: 13pt;
		text-decoration: underline;
	}
</style>